import { render, staticRenderFns } from "./ManagerHome.vue?vue&type=template&id=4b894668&scoped=true"
import script from "./ManagerHome.vue?vue&type=script&lang=ts"
export * from "./ManagerHome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b894668",
  null
  
)

export default component.exports